import { validId, validRevision } from '../domain/training.ts';
import type { TrainingMutation, TrainingCommitReceipt } from '../ports/training-repository.ts';

// Internal envelope shared by the writers using training_receipts. No public port change.
export interface StoredTrainingReceipt {
  operationId: string;
  datasetId: string;
  kind: 'exercise' | 'routine' | 'planning' | 'execution';
  action: 'create' | 'edit' | 'archive' | 'plan' | 'reprogram' | 'omit' | 'start' | 'set' | 'complete' | 'cancel';
  fingerprint: string;
  revisionRef: string;
  receipt: TrainingCommitReceipt & { revision?: number };
  effect?: 'NOOP' | 'CHANGED';
  cancelEffect?: 'RETURN_TO_PLANNED' | 'FINALIZED_INCOMPLETE';
}
export function validTrainingReceipt(value: unknown): value is StoredTrainingReceipt {
  const v = value as StoredTrainingReceipt | undefined;
  return !!v && validId(v.operationId) && validId(v.datasetId)
    && (v.kind === 'execution'
      ? ['start', 'set', 'complete', 'cancel'].includes(v.action) && v.effect === undefined
        && (v.action === 'cancel' ? ['RETURN_TO_PLANNED', 'FINALIZED_INCOMPLETE'].includes(v.cancelEffect ?? '') : v.cancelEffect === undefined)
      : v.cancelEffect === undefined && (v.kind === 'planning'
      ? ['plan', 'reprogram', 'omit'].includes(v.action)
        && (v.action === 'reprogram' ? v.effect === 'NOOP' || v.effect === 'CHANGED' : v.effect === undefined)
      : (v.kind === 'exercise' || v.kind === 'routine') && ['create', 'edit', 'archive'].includes(v.action) && v.effect === undefined))
    && typeof v.fingerprint === 'string' && validId(v.revisionRef)
    && !!v.receipt && v.receipt.operationId === v.operationId && validId(v.receipt.ownerId)
    && (v.action === 'archive' || v.kind === 'execution' ? v.receipt.revision === undefined : validRevision(v.receipt.revision));
}

export function validMutation(command: TrainingMutation): boolean {
  return !!command && validId(command.operationId) && !!command.context
    && validId(command.context.datasetId) && Number.isSafeInteger(command.context.controlEpoch)
    && command.context.controlEpoch >= 0;
}
